import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import type {InternalAddressesStrategyData} from '../../types/internal-addresses-strategy-data.type';
import {InternalAddressesStrategyService} from '../../InternalAddressesStrategyService';


@Service({id: 'internalAddressesCircularStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<InternalAddressesStrategyService> {

  build(details: InternalAddressesStrategyData): InternalAddressesStrategyService {
      return new InternalAddressesStrategyCircular(details);
  }
}

export class InternalAddressesStrategyCircular extends InternalAddressesStrategyService {
  details;

  constructor(details: InternalAddressesStrategyData) {
      super();
      this.details = details;
  }
  isExternalLink(link: string):boolean {
      return true;
  }
}
